module.exports = __webpack_public_path__ + "img/diversity.b544c98c.png";